<template>
  <view class="es-search-history-container" wx:if="{{ historyList.length }}">
    <view class="es-search-record">
      <view class="es-search-record-item" wx:for="{{ historyList }}" wx:key="index" bindtap="changeSelectCity(item)">
        <view>
        {{ item[0].name }} - {{ item[1].name }}
        </view>

      </view>
    </view>
    <!-- <es-icon class="es-clear-icon" name="delete"></es-icon> -->
    <view class="es-clear-history" bindtap="clearHistoryList">清除历史</view>
  </view>
</template>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-search-history-container
    margin-top 9px
    height 21px
    display flex
    justify-content space-between
    color $train-color-999
    font-size 11px
    font-weight 400
    overflow hidden
    .es-clear-icon
      height 22px
      line-height 22px
      margin-right 1px
    .es-clear-history
      width 64px
      height 30px
      line-height 22px
      text-align center
    .es-search-record
      width calc(100% - 50px)
      height 21px
      margin-left 1px
      overflow scroll
      white-space nowrap
      .es-search-record-item
        margin-top 1px
        margin-left 1px
        height 19px
        line-height 19px
        border-radius 4px
        background #FFFFFF
        display inline-block
        margin-right 8px
        padding 0 6px
        z-index 2
        position relative
        box-shadow: 0px 0px 0px 0.5px #CCCCCC
</style>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      historyList: Array
    },
    data: {},
    methods: {
      ...store.mapMutations({
        setHistoryList: 'travel.setHistoryList',
        changeSelectCityList: 'travel.changeSelectCityList'
      }),

      clearHistoryList() {
        trackEvent('userteam_train_home_tickets_ck','UT-火车票-首页-票模块-点击',{ module:'clear' })
        this.setHistoryList([])
      },

      changeSelectCity(detail) {
        trackEvent('userteam_train_home_tickets_ck','UT-火车票-首页-票模块-点击',{ module:'his_search' })
        this.changeSelectCityList({ type: 'currentFromCity', data: detail[0] })
        this.changeSelectCityList({ type: 'currentToCity', data: detail[1] })
      }
    }
  })
</script>

<script name="json">
  module.exports = {
    component: true
  }
</script>
